module.exports = {"310116001":"石化街道","310116101":"朱泾镇","310116102":"枫泾镇","310116103":"张堰镇","310116104":"亭林镇","310116105":"吕巷镇","310116107":"廊下镇","310116109":"金山卫镇","310116112":"漕泾镇","310116113":"山阳镇","310116503":"金山工业区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/310116.json
// module id = 919
// module chunks = 0